// NOTE: 一時的なスパム対策のためにフォームにダミーの値を設定する関数
export default function setDummyFormValue(selector = '.jsDummy', value = '7hs4sk2') {
  $(selector).val(value);
}